module.exports = __webpack_public_path__ + "static/media/foosball.9be42181.svg";